import React from 'react';
import { DateSelection } from '../DateSelection/DateSelection';
import { jsx as _jsx } from "react/jsx-runtime";
export const TvGuideDateSelection = ({
  date,
  analyticsPageId,
  onDateChange,
  onInstantChange
}) => /*#__PURE__*/_jsx(DateSelection, {
  date: date,
  analyticsPageId: analyticsPageId,
  onDateChange: onDateChange,
  onInstantChange: onInstantChange
});